<div>
    <div id="iframeRes">
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/payments/worldpay-xml.component.html